import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetTagAutocompleteParams } from "apis/data-contracts";
import useDebouncedState from "features/common/hooks/useDebouncedState";

const useTagsAutoCompleteQuery = (
  options: Partial<GetTagAutocompleteParams>,
) => {
  const option = useDebouncedState(options, 500);

  return useQuery({
    queryKey: api.tag.getTagAutocompleteKey(option as GetTagAutocompleteParams),
    queryFn: () =>
      api.tag.getTagAutocomplete(option as GetTagAutocompleteParams),
    enabled:
      option?.searchTerm !== undefined && option?.searchTerm.trim() !== "",
    placeholderData: (pre) => pre,
  });
};

export default useTagsAutoCompleteQuery;
